export default class Store {
  constructor() {
    const pills = document.getElementById('v-pills-tab');

    if (document.getElementById('search-form')) {
      this.searchPlaceholderReset();
    }
    if (pills) {
      this.toggleActivePlans();
    }
  }
  searchPlaceholderReset() {
    const searchField = document.getElementById('search');

    if ((window.innerWidth >= '1200' && window.innerWidth <= '1400') || (window.innerWidth >= '768' && window.innerWidth <= '991')) {
      searchField.setAttribute('placeholder', 'Search');
    } else {
      searchField.setAttribute('placeholder', 'Search services, containers, and deployments');
    }
  }
  toggleActivePlans() {
    const hash = window.location.hash.replace('#', ''),
    target = document.getElementById(hash),
    targetContent = document.getElementById('v-pills-' + hash);

    if (hash) {
      document.querySelectorAll('.nav-link, .tab-pane').forEach(element => {
        element.classList.remove('active');
      });

      if (target && targetContent) {
        target.classList.add('active');
        targetContent.classList.add('active');
        targetContent.classList.remove('fade');
      }
    }
  }
}
